import { useEffect } from 'react'
import { useTranslation } from '../hooks/useTranslation'
import UserIcon from '../assets/icons/user.svg'
import TargetIcon from '../assets/icons/award.svg'
import ShieldIcon from '../assets/icons/shield-check.svg'
import UsersIcon from '../assets/icons/users.svg'

const aboutHero = '/images/about-hero.png'
const aboutCompany = '/images/about-company.png'
const aboutTeam = '/images/about-team.png'
const team1 = '/images/team-member-1.png'
const team2 = '/images/team-member-2.png'
const team3 = '/images/team-member-3.png'
const team4 = '/images/team-member-4.png'
const team5 = '/images/team-member-5.png'
const team6 = '/images/team-member-6.png'

export default function About() {
  const { t, getPageTitle, lang } = useTranslation()

  useEffect(() => {
    document.title = getPageTitle('about')
  }, [lang, getPageTitle])

  const team = [
    { name: t('about.team.members.michael.name'), role: t('about.team.members.michael.role'), desc: t('about.team.members.michael.desc'), photo: team2 },
    { name: t('about.team.members.sarah.name'), role: t('about.team.members.sarah.role'), desc: t('about.team.members.sarah.desc'), photo: team1 },
    { name: t('about.team.members.david.name'), role: t('about.team.members.david.role'), desc: t('about.team.members.david.desc'), photo: team3 },
    { name: t('about.team.members.jennifer.name'), role: t('about.team.members.jennifer.role'), desc: t('about.team.members.jennifer.desc'), photo: team4 },
    { name: t('about.team.members.michaelH.name'), role: t('about.team.members.michaelH.role'), desc: t('about.team.members.michaelH.desc'), photo: team5 },
    { name: t('about.team.members.sophia.name'), role: t('about.team.members.sophia.role'), desc: t('about.team.members.sophia.desc'), photo: team6 },
  ]

  return (
    <>
      {/* Hero Section */}
      <section className="hero hero-with-bg">
        <div className="hero-bg-image">
          <img src={aboutHero} alt="Office meeting room" />
          <div className="hero-overlay"></div>
        </div>
        <div className="container hero-content">
          <h1>{t('about.hero.title')}</h1>
          <p>{t('about.hero.subtitle')}</p>
        </div>
      </section>

      {/* Company Info */}
      <section className="about section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>{t('about.company.title')}</h2>
              <p>{t('about.company.description1')}</p>
              <p>{t('about.company.description2')}</p>
              <p>{t('about.company.description3')}</p>
            </div>
            <div className="about-image">
              <div className="about-image-content">
                <img
                  src={aboutCompany}
                  alt="Professional team meeting"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="section section-bg">
        <div className="container">
          <div className="about-stats" style={{ gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
            <div className="stat">
              <span className="stat-number">15+</span>
              <span className="stat-label">{t('about.stats.years')}</span>
            </div>
            <div className="stat">
              <span className="stat-number">500+</span>
              <span className="stat-label">{t('about.stats.cases')}</span>
            </div>
            <div className="stat">
              <span className="stat-number">$50B+</span>
              <span className="stat-label">{t('about.stats.amount')}</span>
            </div>
            <div className="stat">
              <span className="stat-number">98%</span>
              <span className="stat-label">{t('about.stats.satisfaction')}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>{t('about.team.title')}</h2>
            <p>{t('about.team.subtitle')}</p>
          </div>
          <div className="team-grid">
            {team.map((member, index) => (
              <div key={index} className="team-member-card">
                <div className="team-member-photo">
                  <img src={member.photo} alt={member.name} />
                </div>
                <h3>{member.name}</h3>
                <p style={{ color: 'var(--gold)', fontWeight: '500', marginBottom: '8px' }}>
                  {member.role}
                </p>
                <p style={{ fontSize: '14px' }}>{member.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section section-bg">
        <div className="container">
          <div className="section-header">
            <h2>{t('about.values.title')}</h2>
          </div>
          <div className="services-grid">
            <div className="service-card" style={{ textAlign: 'center' }}>
              <div className="service-icon" style={{ margin: '0 auto 24px' }}>
                <img src={TargetIcon} alt="Professionalism" />
              </div>
              <h3>{t('about.values.professionalism.title')}</h3>
              <p>{t('about.values.professionalism.description')}</p>
            </div>
            <div className="service-card" style={{ textAlign: 'center' }}>
              <div className="service-icon" style={{ margin: '0 auto 24px' }}>
                <img src={ShieldIcon} alt="Integrity" />
              </div>
              <h3>{t('about.values.integrity.title')}</h3>
              <p>{t('about.values.integrity.description')}</p>
            </div>
            <div className="service-card" style={{ textAlign: 'center' }}>
              <div className="service-icon" style={{ margin: '0 auto 24px' }}>
                <img src={UsersIcon} alt="Customer" />
              </div>
              <h3>{t('about.values.customer.title')}</h3>
              <p>{t('about.values.customer.description')}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
